import type { RootState } from "../types/store.types";

export const selectMeasureDatasets = (state: RootState) => state.measureDatasets;
export const selectCurrentMetaDataSetId = (state: RootState) => state.metaData.dataSetId;
